import HelperDate from '../../helpers/HelperDate';

interface IProp {
  proposal: any;
}
const ProposalProject = ({ proposal }: IProp) => {

  if ((proposal?.proposalStatus?.name ?? '') !== 'Projeto' || (proposal?.proposalProject))
    return (<></>);

  return (
    <div className="mt-2">
      {
        (proposal?.proposalProject?.statusNew) &&
        <p style={{ marginBottom: 0 }}><b>Status:</b> {proposal?.proposalProject?.statusNew}</p>
      }
      {
        (proposal?.proposalProject?.subStatus) &&
        <p style={{ marginBottom: 0 }}><b>SubStatus:</b> {proposal?.proposalProject?.subStatus}</p>
      }
      {
        (proposal?.proposalProject?.reasonSubStatus) &&
        <p style={{ marginBottom: 0 }}><b>Motivo:</b> {proposal?.proposalProject?.reasonSubStatus}</p>
      }
      {
        (proposal?.proposalProject?.registerDate) &&
        <p style={{ marginBottom: 0 }}><b>Atualizado em:</b> {HelperDate.formatDateAndTime(proposal?.proposalProject?.registerDate)}</p>
      }

    </div>
  );
};

export default ProposalProject;
